import axios from "axios";
import React, { useState } from "react";
import { IoMdClose } from "react-icons/io";
import Select from "react-select";
import { VscLoading } from "react-icons/vsc";

const AddNewDistributor = ({
  orderId,
  setModal,
  setSuccessAPI,
  setErrorAPI,
  setRerender,
}) => {
  const [loading, setLoading] = useState(false);
  const [selectedFlag, setSelectedFlag] = useState(null);
  const [error, setError] = useState(null);

  const options = [
    { value: "primary_holder_kyc", label: "KYC" },
    { value: "bank_details", label: "Bank Details" },
  ];
  const reinitiateLoan = async () => {
    const token = localStorage.getItem("token");
    setLoading(true);
    const options = {
      method: "POST",
      headers: { Authorization: token },
      data: {
        reinitiate_loan: {
          order_uuid: orderId,
          requery_type: selectedFlag
            ? selectedFlag.map((item) => item.value)
            : [],
        },
      },
    };
    try {
      const res = await axios.request(
        `${process.env.REACT_APP_URL}/bajaj_finserv/service/reinitiate_loan`,
        options
      );
      let message = res?.data?.data?.message;
      if (res.data.status === true) {
        setSuccessAPI(message || `Reinitiation successfull`);
        setModal(false);
        setRerender((prev) => !prev);
      } else {
        const errorMessage = res?.data?.error;
        setErrorAPI(message || errorMessage || `Failed to Reinitiate`);
      }
    } catch (error) {
      setErrorAPI("Failed to Reinitiate");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="overlay z-50">
      <div className={`modal !w-[500px] !h-fit !p-0 !text-left `}>
        <div className=" w-full h-full p-6 flex flex-col">
          <div className=" flex justify-between">
            <p className=" text-base font-bold w">Reinitiate Loan</p>
            <button
              onClick={() => {
                setModal(false);
              }}
              className=" cursor-pointer"
            >
              <IoMdClose className=" w-[20px] h-[20px]" />
            </button>
          </div>
          {/* //// */}
          <div className=" flex items-center mt-[24px]">
            <label className=" w-[150px] text-sm font-medium">
              Select Journey
            </label>

            <Select
              className={` ml-2 w-full h-[36px] rounded  text-sm  pl-4 focus:outline-none text-[#00394d] font-medium placeholder:text-xs`}
              isMulti={true}
              placeholder="Select atleast one"
              options={options}
              value={selectedFlag}
              onChange={(e) => {
                setError(null);
                setSelectedFlag(e);
              }}
              isSearchable={false}
            />
          </div>
          {error && (
            <div className="text-red-400  flex space-x-1 items-center mt-2 ">
              <span className="text-xs">{error}</span>
            </div>
          )}
          <div className=" flex justify-end items-center mt-6 ">
            <button
              onClick={() => {
                if (selectedFlag?.length === 0 || selectedFlag === null) {
                  setError("Please select atleast one journey type");
                  return;
                }
                reinitiateLoan();
              }}
              className=" flex  items-center justify-center bg-[#00394d] text-white h-[32px] w-[94px] rounded-lg text-sm font-semibold"
            >
              {loading ? (
                <VscLoading size={16} className=" animate-spin" />
              ) : (
                " Reinitiate "
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddNewDistributor;
